import React, { useEffect } from "react";
import { setCustomerAuthenticate } from "../../services/redux/CustomerAuthentication";
import { useDispatch, useSelector } from "react-redux";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import { setCustomerData } from "../../services/redux/CustomerDataReducer";
import LogoDiv from "../Common/LogoDiv";
import { setSuccessPage } from "../../services/redux/SuccessReducer";
import { setCustomerBankDetails } from "../../services/redux/CustomerBankDataReducer";
import { GenerateReportApiCall } from "../../services/redux/ApiActions";
import showNotification from "../../services/redux/NotifcationService";

const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];

export default function Success() {
        const details = useSelector((state) => state.details.details);
        const customerData = useSelector((state) => state.customerData.customerData);
        const dispatch = useDispatch();
                    // dispatch(setDetailsData(''))
                    // dispatch(setCustomerData(''))
                    // dispatch(setCustomerBankDetails(null))

        const generateReport = async () => {
        const payload = {
       "gstin": details?.result?.gstin,
       "pan": details?.result?.pan,
       "corporateId":customerData?.custId,
       "corporateType": 1
       }
         try {
                const data = await dispatch(GenerateReportApiCall(payload, customerData?.token_chr));
                if (data) {
                            dispatch(setDetailsData(''))
                    dispatch(setCustomerData(''))
                    dispatch(setCustomerBankDetails(null))
                    dispatch(setSuccessPage(false));
                }
        } catch (error) {
            showNotification(error, 'error');
        }
    }

                

    useEffect(() => {
        if(customerData?.custId){
            generateReport();
        }
    }, [])

    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <div className='bg-white mx-2 shadow-2xl p-6 mt-14 rounded-lg'>
                                    <div className="py-2 mt-3 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">CONGRATULATIONS
                                        </h1>
                                    </div>
                                    <div className="flex justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#A5DC86" style={{ width: '100px' }}>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    </div>
                                    <div className="text-center mt-4 mb-3">
                                        <label className="text-xl font-normal text-gray-500">You profile has been submitted for approval.
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body>
        </>
    );
}